import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import throttle from 'lodash/throttle';
import { prefetch } from '../../prefetch';
import { performanceNow } from '../../common/utils/performance-now';
import { NAVIGATION_CHANNEL, NavigationAnalyticsContext, OPERATIONAL_EVENT_TYPE, TRIGGER_COMPONENT, TRIGGER_SUBJECT, withAnalyticsEvents } from '../../common/utils/analytics';
import packageContext from '../../common/utils/package-context';
var THROTTLE_EXPIRES = 60 * 1000; // 60 seconds
var THROTTLE_OPTIONS = {
  leading: true,
  trailing: false
};
var TRIGGER_CONTEXT = _objectSpread({
  componentName: TRIGGER_COMPONENT
}, packageContext);
var PrefetchTrigger = /*#__PURE__*/function (_React$Component) {
  function PrefetchTrigger() {
    var _this;
    _classCallCheck(this, PrefetchTrigger);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, PrefetchTrigger, [].concat(args));
    _defineProperty(_this, "fireOperationalEvent", function (payload) {
      if (_this.props.createAnalyticsEvent) {
        _this.props.createAnalyticsEvent(_objectSpread({
          eventType: OPERATIONAL_EVENT_TYPE,
          actionSubject: TRIGGER_SUBJECT
        }, payload)).fire(NAVIGATION_CHANNEL);
      }
    });
    _defineProperty(_this, "triggerPrefetch", throttle(function () {
      prefetch(_this.props);
      _this.fireOperationalEvent({
        action: 'triggered'
      });
    }, THROTTLE_EXPIRES, THROTTLE_OPTIONS));
    _defineProperty(_this, "handleMouseEnter", function () {
      _this.triggerPrefetch();
      _this.lastEnteredAt = performanceNow();
    });
    _defineProperty(_this, "handleMouseClick", function () {
      if (_this.lastEnteredAt) {
        var hoverToClick = Math.round(performanceNow() - _this.lastEnteredAt);
        _this.fireOperationalEvent({
          action: 'clicked',
          attributes: {
            hoverToClick: hoverToClick
          }
        });
      }
    });
    return _this;
  }
  _inherits(PrefetchTrigger, _React$Component);
  return _createClass(PrefetchTrigger, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        _this$props$Container = _this$props.Container,
        Container = _this$props$Container === void 0 ? 'div' : _this$props$Container;
      return /*#__PURE__*/React.createElement(Container, {
        onFocus: this.handleMouseEnter,
        onMouseEnter: this.handleMouseEnter,
        onClick: this.handleMouseClick
      }, children);
    }
  }]);
}(React.Component);
var PrefetchTriggerWithEvents = withAnalyticsEvents()(PrefetchTrigger);
export default (function (props) {
  return /*#__PURE__*/React.createElement(NavigationAnalyticsContext, {
    data: TRIGGER_CONTEXT
  }, /*#__PURE__*/React.createElement(PrefetchTriggerWithEvents, props));
});